import { VitaDocumentThemeColor } from '@xing-com/crate-common-graphql-types';
import type { VitaDocumentThemeTemplate } from '@xing-com/crate-common-graphql-types';
import { templates } from '@xing-com/crate-lebenslauf-constants';

export const isValidTemplate = (
  template?: string
): template is VitaDocumentThemeTemplate => {
  return Boolean(templates.find(({ name }) => name === template));
};

export const isValidColor = (
  color?: string
): color is VitaDocumentThemeColor => {
  switch (color) {
    case VitaDocumentThemeColor.Brown:
    case VitaDocumentThemeColor.DarkBlue:
    case VitaDocumentThemeColor.DarkGreen:
    case VitaDocumentThemeColor.Grey:
    case VitaDocumentThemeColor.LightBlue:
    case VitaDocumentThemeColor.LightGreen:
    case VitaDocumentThemeColor.LightSea:
    case VitaDocumentThemeColor.Orange:
    case VitaDocumentThemeColor.Pink:
    case VitaDocumentThemeColor.Purple:
      return true;
    default:
      return false;
  }
};
